import { cascadesign } from '../request';
export default {
  props: {
    // index: {
    //   type: Number
    // },
    // controlMark: {
    //   type: String
    // }
    formData: {
      type: Object,
      default: () => {}
    },
    itemData: {
      type: Object,
      default: () => {}
    },
    isEdit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      canvasContext: null,
      signatureIMAGE: '',
      isDrawing: false,
      lastX: 0,
      lastY: 0,
      canvasWidth: 870,
      canvasHeight: 200,
      isSignatureEmpty: false,
      //清除
      isUploading: true,
      //上传
      showSignature: true,
      // 控制签名的显示和隐藏状态
      imgurl: '',
      showDraw: true
    };
  },
  computed: {
    indexID() {
      return this.index;
    }
  },
  mounted() {
    if (this.$refs.canvas) {
      this.canvasContext = this.$refs.canvas.getContext('2d');
      this.resizeCanvas();
      window.addEventListener('resize', this.resizeCanvas);
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeCanvas);
  },
  methods: {
    async getcascadesign(item) {
      const currentOptions = await cascadesign({
        sign: item
      });
      this.imgurl = currentOptions.fileTempUrl;
      this.$emit('update:controlMark', currentOptions.fileTempUrl);
      this.isUploading = true; // 点击上传把上传按钮置灰

      this.showSignature = false; // 成功上传后隐藏签名
      // this.itemMark = currentOptions;
    },
    startDrawing(event) {
      this.isDrawing = true;
      this.lastX = event.clientX - this.$refs.canvas.getBoundingClientRect().left;
      this.lastY = event.clientY - this.$refs.canvas.getBoundingClientRect().top;
      this.isUploading = false;
    },
    draw(event) {
      console.log('this.isDrawing', this.isDrawing);
      if (!this.isDrawing) return;
      if (!this.canvasContext) {
        this.canvasContext = this.$refs.canvas.getContext('2d');
        this.resizeCanvas();
        window.addEventListener('resize', this.resizeCanvas);
      }
      this.$nextTick(() => {
        const x = event.clientX - this.$refs.canvas.getBoundingClientRect().left;
        const y = event.clientY - this.$refs.canvas.getBoundingClientRect().top;
        console.log('x', x, 'y', y);
        this.canvasContext.beginPath();
        this.canvasContext.lineWidth = 2; // 设置线条宽度为2像素（根据需求调整宽度）
        this.canvasContext.moveTo(this.lastX, this.lastY);
        this.canvasContext.lineTo(x, y);
        this.canvasContext.stroke();
        this.lastX = x;
        this.lastY = y;
      });
    },
    stopDrawing() {
      this.isDrawing = false;
    },
    // 清空
    clearCanvas() {
      // this.isUploading = true;
      // this.canvasContext.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
      this.controlMark = '';
      this.$emit('update:controlMark', this.controlMark);
      if (!this.controlMark) {
        this.$nextTick(() => {
          this.canvasContext = this.$refs.canvas.getContext('2d');
          this.resizeCanvas();
        });
      }

      // this.formDataArray[this.indexID].url = '';
      // this.$emit('my-event', this.formDataArray[this.indexID].url == '');
      this.isUploading = true; // 点击清空把上传按钮置灰
      this.showSignature = true; // 清空画布后显示签名
    },
    // 上传
    saveSignature() {
      const signatureData = this.$refs.canvas.toDataURL();
      // console.log('获取URL地址', signatureData);
      // this.formDataArray[this.indexID].url = signatureData;
      // this.getcascadesign(this.formDataArray[this.indexID].url);

      // console.log('555555------55', signatureData);

      this.getcascadesign(signatureData);
      this.isUploading = true; //点击上传把上传按钮置灰

      // this.$emit('my-event', this.formDataArray[this.indexID].url);
    },
    resizeCanvas() {
      const container = this.$refs.canvas.parentElement;
      this.canvasWidth = container.offsetWidth;
      this.canvasHeight = container.offsetHeight;
      this.$refs.canvas.width = this.canvasWidth;
      this.$refs.canvas.height = this.canvasHeight;
    },
    mouseLeave() {
      this.isDrawing = false;
    }
  }
};